var map = {
	"./Avatar.svg": "8db2",
	"./add.svg": "eef4",
	"./ban.svg": "75cd",
	"./bug.svg": "c0e3",
	"./config-fail.svg": "1487",
	"./config-success.svg": "e634",
	"./cross.svg": "89fe",
	"./ctf-logo.svg": "17c9",
	"./deployChallenges.svg": "5369",
	"./download.svg": "6369",
	"./dropdown.svg": "8cc0",
	"./edit.svg": "6582",
	"./error-page.svg": "3c8d",
	"./error-white.svg": "c183",
	"./error.svg": "2ee5",
	"./fb-logo.svg": "cba0",
	"./github-logo.svg": "4766",
	"./labs-logo-dark.svg": "b9ae",
	"./landing1.svg": "50d9",
	"./landing2.svg": "a508",
	"./leaderboard.svg": "7cea",
	"./lens.svg": "8909",
	"./login.svg": "ebec",
	"./mail.svg": "1752",
	"./main-logo-dark.svg": "5086",
	"./main-logo.svg": "af86",
	"./maintenance-msg.svg": "fc45",
	"./maintenance.svg": "8817",
	"./marked.svg": "c1b2",
	"./new-tag.svg": "9e89",
	"./notif-added.svg": "1d1b",
	"./notif-failed.svg": "209b",
	"./play.svg": "5830",
	"./playctf-logo.svg": "94cf",
	"./preview.svg": "94bf",
	"./purge.svg": "0fc7",
	"./purgeChallenges.svg": "70b4",
	"./registration.svg": "c51f",
	"./rocket.svg": "67e3",
	"./sds-logo.svg": "eb8a",
	"./sdslabs-logo-dark.svg": "f59d",
	"./sdslabs-logo.svg": "3cca",
	"./search.svg": "51f2",
	"./submit-fail.svg": "bf1b",
	"./submit-success.svg": "aa81",
	"./tick-white.svg": "2f0e",
	"./tick.svg": "4ab9",
	"./twitter-logo.svg": "3a89",
	"./unban.svg": "8f5a",
	"./undeploy.svg": "f64b",
	"./undeployChallenges.svg": "9691",
	"./unmarked.svg": "5eb1",
	"./upload-fail.svg": "6024",
	"./upload-success.svg": "5573",
	"./upload.svg": "c118",
	"./user-challenge.svg": "f954",
	"./userPanel.svg": "659c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";